import React from "react";
import { COLORS, RADIUS, SHADOW } from "../../theme";

const VARIANTS = {
  primary: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #145CFF 100%)`,
    color: COLORS.white,
    border: "none",
    boxShadow: SHADOW.raised,
  },
  secondary: {
    background: COLORS.white,
    color: COLORS.primary,
    border: `1.5px solid ${COLORS.border}`,
    boxShadow: "none",
  },
  danger: {
    background: COLORS.danger,
    color: COLORS.white,
    border: "none",
    boxShadow: "0 4px 16px rgba(239,68,68,0.28)",
  },
  ghost: {
    background: "transparent",
    color: COLORS.textMid,
    border: "none",
    boxShadow: "none",
  },
};

export default function Btn({ variant = "primary", disabled, style, children, ...props }) {
  const v = VARIANTS[variant] || VARIANTS.primary;
  return (
    <button
      disabled={disabled}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: "11px 20px",
        borderRadius: RADIUS.md,
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: "0.01em",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transition: "transform .15s, opacity .15s, box-shadow .15s",
        ...v,
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
      {...props}
    >
      {children}
    </button>
  );
}
